export default "__VITE_ASSET__B$gjMzlo__"